/**
 * Grid of outcome counts for a bulk RMA action request (total, succeeded, blocked, etc.).
 */
import { IBulkRmaActionReturnCounts } from '../../../../../../services/api/troubleshooting-service';

interface ICountsGridProps {
    counts: IBulkRmaActionReturnCounts;
}

const CountsGrid: React.FC<ICountsGridProps> = ({ counts }) => (
    <div className="bulk-rma-actions-page__counts-grid">
        {Object.entries(counts).map(([key, value]) => (
            <div key={key} className="bulk-rma-actions-page__count-cell">
                <span className="bulk-rma-actions-page__count-label">{key}</span>
                <span className="bulk-rma-actions-page__count-value">{value}</span>
            </div>
        ))}
    </div>
);

export default CountsGrid;
